import { OnInit, Component, Input } from "@angular/core";
import { CompareDto } from "src/DTOs/Cases/Models/Compare/CompareDto";
import { MessageStatus } from "src/core/enums/MessageStatus";

@Component({
    selector: "compare-survey-results",
    templateUrl: './compare-survey-results.component.html',
    styleUrls: ['./compare-survey-results.component.scss']
})
export class CompareSurveyResultsComponent implements OnInit {

    public ProcedureDayMessageStatusScheduled = MessageStatus.Value("scheduled");
    public ProcedureDayMessageStatusResponded = MessageStatus.Value("surveyresponded");
    public ProcedureDayMessageStatusSent = MessageStatus.Value("sent");
    public ProcedureDayMessageStatusError = MessageStatus.Value("error");
    public ProcedureDayMessageStatusHalted = MessageStatus.Value("halted");

    @Input()
    public compareData: CompareDto;

    @Input()
    public questionGroups: any[];

    ngOnInit(): void {
        
    }

}